"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = _interopRequireDefault(require("./../context"));

var _confirmDialog = _interopRequireDefault(require("../components/confirm-dialog"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    modals: state.modals
  };
};

var ModalRootContainer = function ModalRootContainer(props) {
  var renderModal = function renderModal(modal) {
    return _react["default"].createElement(_confirmDialog["default"], (0, _extends2["default"])({}, modal.props, {
      type: modal.type,
      key: modal.modalKey,
      modalKey: modal.modalKey
    }));
  };

  return _react["default"].createElement("div", {
    className: "modal-root"
  }, props.modals.map(renderModal));
}; // TODO: Extract this out to somewhere


var connect = function connect(mapState) {
  return function (WrappedComponent) {
    return function (props) {
      var _useContext = (0, _react.useContext)(_context["default"]),
          state = _useContext.state,
          dispatch = _useContext.dispatch;

      return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, mapState(state, props), {
        dispatch: dispatch
      }));
    };
  };
};

ModalRootContainer.propTypes = {
  modals: _propTypes["default"].array
};
var instance = connect(mapStateToProps)(ModalRootContainer);
var _default = instance;
exports["default"] = _default;